import Swal from "sweetalert2";
import { fetchToken } from "../helpers/fetch";
import { const_routes } from "../helpers/const_routes";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { loadingModuleConfigsTechnology } from "./moduleConfigActions";
import { getMenus, setMenuPathsForCompare, setIsLoadingMenuPaths } from "./menuActions";

import { getRolesByUserIdLogin, getUserRoles, syncActiveSpecialistRoleAfterLogin } from "./userRoleActions";
import { getAllPaths } from "../helpers/getAllPaths";
import { mergeMenuPathsWithPermitted } from "../helpers/allowedPermitPathsHelper";
import { debugLogActions } from "../helpers/debugHelper";
import { filterMenusByRuntimeFlags } from "../helpers/flowEngineConfigHelper";

export const startGetRolesMenusByUserId = (user_id) => {
  return async (dispatch, getState) => {

    dispatch(setIsLoadingMenuPaths())

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_OPTIMIZATION}`,
      `get-roles-menus-by-userid/${user_id}`
    );
    const body = await resp.json();

    debugLogActions('---> startGetRolesMenusByUserId', { 'body': body });

    if (body.ok) {

      const loginRoles = body.userRoles || [];
      const remappedRoles = getUserRoles(loginRoles, loginRoles.length);
      const userRoleProcess = {
        ...body.userRoleProcess,
        ...remappedRoles,
        moduleAccessByRole: body.userRoleModuleProcess?.moduleAccessByRole || {},
        moduleAccess: body.userRoleProcess?.moduleAccess || []
      };

      dispatch(getRolesByUserIdLogin(userRoleProcess));
      dispatch(syncActiveSpecialistRoleAfterLogin(userRoleProcess, user_id));

      const configurationState = getState()?.configuration || {};
      const menus = filterMenusByRuntimeFlags(body.menus.flat(), configurationState, getState()?.userRole);
      
      dispatch(getMenus(menus));

      const allowedPaths = getAllPaths(menus);
      const allowedPathsUnion = mergeMenuPathsWithPermitted(allowedPaths);

      dispatch(setMenuPathsForCompare(allowedPathsUnion));

      const module = "TECHNOLOGY";
      if (module === "TECHNOLOGY") {
        dispatch(loadingModuleConfigsTechnology(body.moduleConfigs));
      }

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

/*const getRolesByUserIdLogin = (userRole) => ({
  type: types.USERROLE_LOGIN,
  payload: userRole,
});*/